import { jobLists } from "character";
import NoCharacter from "components/no-character/NoCharacter";
import { GameData, RelicData, View } from "enums";
import manager from "managers/app";
import { ViewRelicInfo } from "managers/types/relic-types";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import { Requirement } from "views/page-parts/content/relic-requirements/types";
import { ViewArmourAnemosBase2Props } from "views/relics/armour/anemos/base-2/types";
import "./ArmourAnemosBase2.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		userInfo: state.userInfo,
		hideCompletedSteps: state.userInfo.options.hideCompletedSteps,
		hideCompletedTasks: state.userInfo.options.hideCompletedTasks,
		showJob: state.userInfo.options.job,
	};
};

class ArmourAnemosBase2 extends Component<ViewArmourAnemosBase2Props> {
	private requirements:Requirement[] = [];
	private importantNPCs:GameData.NPC[] = [];
	private relicInfo:ViewRelicInfo = {
		jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
		type: RelicData.Type.WEAPON,
		relic: RelicData.Group.WEAPON_ZODIAC,
		part: RelicData.Part.WEAPON_ZENITH,
		steps: [RelicData.Step.MIST],
		stepPlaceholders: {},
		next: {
			part: RelicData.Part.WEAPON_ATMA,
			view: View.RELIC_WEAPONS_ZODIAC_ATMA,
		},
		previous: {
			part: RelicData.Part.WEAPON_BASE_WEAPON,
			view: View.RELIC_WEAPONS_ZODIAC_BASE_WEAPON,
		},
	};

	constructor(props:ViewArmourAnemosBase2Props){
		super(props);
		this.requirements = this.getRequirements();
		this.importantNPCs = this.getImportantNPCs();
	}

	render():JSX.Element{
		const character = manager.data.getActiveCharacter();
		if(character === null){ return <NoCharacter />; }

		return (
			<div id="armour-anemos-Base2" className="relic">
				<h1 style={{ textAlign: "center" }}>{t.t("Coming Soon!")}</h1>
			</div>
		);
	}

	componentDidMount(){
		manager.view.changeComplete();
	}

	private getRequirements():Requirement[]{
		if(!this.relicInfo || this.relicInfo.previous === null){ return []; }
		return [
			{ type: "previous part", part: this.relicInfo.previous.part, partView: this.relicInfo.previous.view },
		];
	}

	private getImportantNPCs():GameData.NPC[]{
		return [];
	}
}
export default connect(mapStateToProps)(ArmourAnemosBase2);
